import { render, staticRenderFns } from "./CourseEvaluationParameterConfigurationPage.vue?vue&type=template&id=403c3474"
import script from "./CourseEvaluationParameterConfigurationPage.vue?vue&type=script&lang=js"
export * from "./CourseEvaluationParameterConfigurationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports